<div
  animate.enter="toast-fade-in"
  class="toast"
  [class.toast-fade-out]="destroy()"
  (click)="remove()"
  [class]="'toast-' + toastData.type">
  @if (title) {
    <div [class]="options.titleClass" [attr.aria-label]="title">
      {{ title }}
      @if (duplicatesCount) {
        [{{ duplicatesCount + 1 }}]
      }
    </div>
  }

  @if (message) {
    @if (options.enableHtml) {
      <div role="alert" [class]="options.messageClass" [innerHTML]="message"></div>
    } @else {
      <div role="alert" [class]="options.messageClass" [attr.aria-label]="message">
        {{ message }}
      </div>
    }
  }

  @if (options.progressBar) {
    <div class="toast-progress"></div>
  }
</div>
